module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#dbdbdb"
    }
  }, [_c('section', {
    ref: "personalCenter",
    staticClass: "personal-center"
  }, [_c('span', {
    staticClass: "sidebarbutton"
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-md navbar-light",
    staticStyle: {
      "font-color": "#0082BA",
      "font-size": "16px",
      "font-weight": "bold",
      "max-width": "1440px",
      "margin": "auto"
    },
    attrs: {
      "id": "navbar"
    }
  }, [_c('button', {
    staticClass: "toggler-icon btn btn-info",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  }), _vm._v(" Action Menu\n          "), _c('i', {
    staticClass: "fa fa-sort-desc fa-2x",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('nav', {
    class: {
      active: _vm.active
    },
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    staticClass: "userimg lightbluebg",
    staticStyle: {
      "background": "#d92638",
      "padding": "18px 0 18px 16px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.userImg,
      "intrinsicsize": "52 x 52"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "p-3"
  }, [_vm._v(_vm._s(_vm.employer.name))])]), _vm._v(" "), _c('ul', {
    staticClass: "personal-center__nav-list"
  }, [_c('router-link', {
    class: ['personal-center__nav-list-item--my-loan', _vm.$route.meta.name === 'myLoan' ? 'active' : ''],
    attrs: {
      "to": "/personalCenter/myLoan/loanLists",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setActive.apply(null, arguments)
      }
    }
  }, [_vm._v("My Loans")]), _vm._v(" "), (this.appliedProductName != 'SBRE_product') ? _c('router-link', {
    class: ['personal-center__nav-list-item--business', _vm.$route.meta.name === 'business' ? 'active' : ''],
    attrs: {
      "to": "/personalCenter/BusinessInfo",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setActive.apply(null, arguments)
      }
    }
  }, [_vm._v("Business Info")]) : _vm._e(), _vm._v(" "), (this.appliedProductName != 'SBRE_product') ? _c('router-link', {
    class: ['personal-center__nav-list-item--my-info', _vm.$route.meta.name === 'myInfo' ? 'active' : ''],
    attrs: {
      "to": "/personalCenter/myInfo/PersonInfo",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setActive.apply(null, arguments)
      }
    }
  }, [_vm._v("Personal Details")]) : _vm._e(), _vm._v(" "), (this.appliedProductName == 'SBRE_product') ? _c('router-link', {
    class: ['personal-center__nav-list-item--my-loan', _vm.$route.query === 'updateLoan' ? 'active' : ''],
    attrs: {
      "to": "/personalCenter/updateLoan?type=realEstate",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setActive.apply(null, arguments)
      }
    }
  }, [_vm._v("Application Detail")]) : _vm._e(), _vm._v(" "), (this.appliedProductName == 'SBEL_product') ? _c('router-link', {
    class: ['personal-center__nav-list-item--my-loan', _vm.$route.query === 'updateEquipment' ? 'active' : ''],
    attrs: {
      "to": "/personalCenter/updateEquipment?type=equipment",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setActive.apply(null, arguments)
      }
    }
  }, [_vm._v("Equipment Details")]) : _vm._e(), _vm._v(" "), (this.appliedProductName == 'SBIF_product') ? _c('router-link', {
    class: ['personal-center__nav-list-item--my-loan', _vm.$route.query === 'updateBilling' ? 'active' : ''],
    attrs: {
      "to": "/personalCenter/updateBilling?type=billing",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setActive.apply(null, arguments)
      }
    }
  }, [_vm._v("Billing Details")]) : _vm._e(), _vm._v(" "), (this.appliedProductName == 'SB2M_product') ? _c('router-link', {
    class: ['personal-center__nav-list-item--my-loan'],
    attrs: {
      "to": "/personalCenter/updateBilling?type=property",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setActive.apply(null, arguments)
      }
    }
  }, [_vm._v("Property Details")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    class: ['personal-center__nav-list-item--file-uploading', _vm.$route.query === 'updateBilling' ? 'active' : ''],
    attrs: {
      "to": "/personalCenter/file-upload",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setActive.apply(null, arguments)
      }
    }
  }, [_vm._v("File Upload")]), _vm._v(" "), _c('router-link', {
    class: ['personal-center__nav-list-item--update-password', _vm.$route.query === 'updateBilling' ? 'active' : ''],
    attrs: {
      "to": "/personalCenter/updatePassword",
      "tag": "li"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setActive.apply(null, arguments)
      }
    }
  }, [_vm._v("Reset Password")]), _vm._v(" "), _c('li', {
    staticClass: "personal-center__nav-list-item--my-loan",
    on: {
      "click": _vm.startApply
    }
  }, [_vm._v("Need A Loan")]), _vm._v(" "), _c('li', {
    staticClass: "personal-center__nav-list-item--my-info",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Log Out")])], 1)]), _vm._v(" "), _c('router-view', {
    staticClass: "personal-center__router-view"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2 col-sm-0 p-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-sm-8 p-3"
  }, [_c('el-dialog', {
    attrs: {
      "title": "notice",
      "visible": _vm.centerDialogVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("Are you sure you want to log out?")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.centerDialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirmLogout
    }
  }, [_vm._v("OK")])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-sm-1 p-3"
  })]), _vm._v(" "), _c('el-dialog', {
    staticClass: "contract-dialog",
    attrs: {
      "top": "5%",
      "title": "Declaration",
      "visible": _vm.showAgreementDialog,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "before-close": _vm.handleDialogClose
    },
    on: {
      "update:visible": function($event) {
        _vm.showAgreementDialog = $event
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('img', {
    staticClass: "img-fluid logo",
    attrs: {
      "src": require('../assets/imgs/American Credit_logo_TM_a.png'),
      "alt": "American Credit Logo"
    }
  })]), _vm._v(" "), (_vm.showSignDeclarationWarning) ? _c('div', [_c('h4', {
    staticStyle: {
      "color": "red",
      "text-align": "center"
    }
  }, [_vm._v("Please sign declaration file first.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "contract__dialog-body agreement_contract declaration__dialog-body"
  }, [_c('img', {
    attrs: {
      "src": _vm.readContract,
      "alt": "read"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.signBtn.isShow) ? _c('el-button', {
    staticClass: "dialog__footer__confirm-btn sign_btn",
    staticStyle: {
      "margin-right": "30px"
    },
    attrs: {
      "disabled": _vm.signBtn.state
    },
    on: {
      "click": _vm.showSignAgreement
    }
  }, [_vm._v(_vm._s(_vm.signBtn.text))]) : _vm._e(), _vm._v(" "), (!_vm.signBtn.isShow) ? _c('el-button', {
    staticClass: "dialog__footer__confirm-btn sign_btn",
    staticStyle: {
      "margin-right": "30px"
    },
    attrs: {
      "disabled": _vm.signBtn.state
    },
    on: {
      "click": _vm.downAgreement2
    }
  }, [_vm._v("Download Declaration")]) : _vm._e(), _vm._v(" "), (!_vm.signBtn.isShow) ? _c('el-button', {
    staticClass: "dialog__footer__confirm-btn continue_btn",
    staticStyle: {
      "margin-right": "30px"
    },
    attrs: {
      "disabled": _vm.signBtn.state
    },
    on: {
      "click": _vm.hideAgreement
    }
  }, [_vm._v("Continue Application")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "showSignDialog",
    attrs: {
      "title": "Please type in your full name to sign the declaration digitally",
      "visible": _vm.showSignDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showSignDialog = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Please input your full name to sign",
      "auto-complete": "off"
    },
    on: {
      "change": _vm.allowSubmit
    },
    model: {
      value: (_vm.fullName),
      callback: function($$v) {
        _vm.fullName = $$v
      },
      expression: "fullName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showSignDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.allowSubmitBut
    },
    on: {
      "click": _vm.signAgreement
    }
  }, [_vm._v("Sign")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "showSignDialog",
    attrs: {
      "title": "Please select which loan you would like to apply",
      "visible": _vm.showSelectLoanDialog,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showSelectLoanDialog = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', [_c('el-select', {
    staticClass: "select_loan_width",
    attrs: {
      "placeholder": "Select loan to apply"
    },
    on: {
      "change": _vm.onLoanChange
    },
    model: {
      value: (_vm.loan),
      callback: function($$v) {
        _vm.loan = $$v
      },
      expression: "loan"
    }
  }, _vm._l((_vm.loanS), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showSelectLoanDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.allowApplyBut
    },
    on: {
      "click": _vm.continueApply
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e07a0f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/PersonalCenter.vue
// module id = 1969
// module chunks = 5